import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { EntryOptionDTO, IEntryOptionDTO } from './entry.option.dto';
import { EntrySectionDTO, IEntrySectionDTO } from './entry.section.dto';

export enum FieldTypeEnum {
  Date = 'DATE',
  Text = 'TEXT',
  Number = 'NUMBER',
  Select = 'SELECT',
  MultiSelect = 'MULTI_SELECT',
  Checkbox = 'CHECKBOX',
  Radio = 'RADIO',
  File = 'FILE',
  TextArea = 'TEXT_AREA',
}

export interface IEntryFieldDTO extends IBaseEntityDTO {
  name: string;
  description: string;
  is_required: boolean;
  order: number;
  type: FieldTypeEnum;
  options: IEntryOptionDTO[];
  section: IEntrySectionDTO;
  hasOptions: () => boolean;
}

export class EntryFieldDTO extends BaseEntityDTO implements IEntryFieldDTO {
  name: string;
  description: string;
  is_required: boolean;
  order: number;
  type: FieldTypeEnum;
  options: IEntryOptionDTO[];
  section: IEntrySectionDTO;

  constructor(data?: Partial<IEntryFieldDTO>) {
    super(data);
    this.name = data?.name ?? '';
    this.description = data?.description ?? '';
    this.is_required = data?.is_required ?? false;
    this.order = data?.order ?? 0;
    this.type = data?.type ?? FieldTypeEnum.Text; // Default to Text type if not provided
    this.options = data?.options ? data.options.map((option) => new EntryOptionDTO(option)) : [];
    this.section = data?.section ? new EntrySectionDTO(data.section) : new EntrySectionDTO();
  }
  hasOptions = (): boolean => {
    return [FieldTypeEnum.Select, FieldTypeEnum.MultiSelect, FieldTypeEnum.Radio].includes(
      this.type,
    );
  };
}
